import * as _ from 'lodash'
import { Cursor } from './lib/Cursor'


export function unreachable(thing: never): never;
export function unreachable(thing: any) {
  throw new Error("Unreachable step reached: " + JSON.stringify(thing))
}

function standardSCUCustomizer(item: any, other: any): boolean | undefined {
  if (item instanceof Cursor) {
    return other instanceof Cursor && item.equals(other)
  } else if (typeof item === 'function') {
    return true
  } else {
    return undefined
  }
}

export function propsChanged(props: any, nextProps: any) {
  return !_.isEqualWith(props, nextProps, standardSCUCustomizer)
}

export function standardSCU(this: {props: any, state: any}, nextProps: any, nextState: any): boolean {
  return propsChanged(this.props, nextProps) || this.state !== nextState
}

export function throwError<T>(message: string): T {
  throw new Error(message)
}

export function clog(...args: Array<any>) {
  console.log(...args)
  return args[args.length - 1]
}

export function caller(level: number) {
  const stack = new Error().stack
  return stack ? stack.split('\n')[level] : "UNKNOWN"
}


export function arrInsert<T>(arr: Array<T>, n: number, ...values: Array<T>) {
  return [...arr.slice(0, n), ...values, ...arr.slice(n)]
}

export function arrRemove<T>(arr: Array<T>, n: number) {
  return [...arr.slice(0, n), ...arr.slice(n + 1)]
}


// =============================================================================
// Precision
// =============================================================================

export function precision (x: string) {
  // TODO: Deal with eE stuff.
  const decimalIndex = x.indexOf(".");
  if (decimalIndex === -1) { return 0; }
  return x.length - decimalIndex - 1;
};

export function toPrecision (x: number, precision: number) {
  x = roundToPrecision(x, precision);
  return x.toFixed(precision);
};

export function toMaxPrecision (x: number, precision: number) {
  let xString = toPrecision(x, precision);
  if (xString.indexOf(".")) {
    xString = xString.replace(/\.?0+$/, "");
  }
  return xString;
};

export function roundToPrecision (x: number, precision: number) {
  const multiplier = Math.pow(10, precision);
  x = Math.round(x * multiplier) / multiplier;
  return x;
};


// =============================================================================
// DOM
// =============================================================================

export function matches(el: Element, selector: string) {
  return el.webkitMatchesSelector(selector)
}

// =============================================================================
// lodash
// =============================================================================

// For use in _.isEqualWith; assumes that functions are all equal cuz otherwise you're screwed
// export function customizerFunctionsEqual(objValue, othValue) {
//   if (objValue instanceof Function && othValue instanceof Function) {
//     return true;
//   }
// }


// =============================================================================
// React
// =============================================================================

// export function likelyChanged(self, nextProps, nextState) {
//   const toReturn = !(_.isEqualWith(self.props, nextProps, customizerFunctionsEqual) && _.isEqual(self.state, nextState))
//   if (!toReturn) {console.log("yay!")}
//   return toReturn
// }



// WEBPACK FOOTER //
// ./src/util.ts